import React from 'react'
import parse, { domToReact } from 'html-react-parser'

export const replaceTokens = (text, tokens = {}) => {
  const replacements = {}
  Object.keys(tokens).forEach((key) => {
    replacements[`{${key}}`] = tokens[key]
  })

  if (text && Object.keys(replacements).length) {
    const re = new RegExp(Object.keys(replacements).join('|'), 'gi')
    const result = text.replace(re, (matched) => {
      return replacements[matched]
    })

    return result
  }

  return text
}

export const renderRichTextLine = (textLine = '') => {
  return {
    data: {},
    content: [
      {
        data: {},
        content: [
          {
            data: {},
            marks: [],
            value: textLine,
            nodeType: 'text'
          }
        ],
        nodeType: 'paragraph'
      }
    ],
    nodeType: 'document'
  }
}

export const parseHtmlStringToJSX = (htmlString) => {
  const parseOptions = {
    replace: (node) => {
      if (node.type === 'tag') {
        if (node.name === 'ul' || node.name === 'ol') {
          return <ol className="c-ordered-list">{domToReact(node.children, parseOptions)}</ol>
        }

        if (node.name === 'li') {
          return (
            <li>
              <span>{domToReact(node.children, parseOptions)}</span>
            </li>
          )
        }
      }
      return node
    }
  }
  return htmlString ? parse(htmlString, parseOptions) : null
}
